export const analyzePaginationStructure = (data: any) => {
  let paginationInfo = {
    atual: 1,
    estimated: 1,
    hasBefore: false,
    hasAfter: false,
    hasMorePages: false,
  };

  if (data?.pages) {
    paginationInfo = {
      atual: data.pages.atual || 1,
      estimated: data.pages.estimated || 1,
      hasBefore: data.pages.hasBefore || false,
      hasAfter: data.pages.hasAfter !== false,
      hasMorePages: data.pages.hasAfter !== false,
    };
  } else if (data?.data?.pages) {
    paginationInfo = {
      atual: data.data.pages.atual || 1,
      estimated: data.data.pages.estimated || 1,
      hasBefore: data.data.pages.hasBefore || false,
      hasAfter: data.data.pages.hasAfter !== false,
      hasMorePages: data.data.pages.hasAfter !== false,
    };
  } else if (data?.pagination) {
    paginationInfo = {
      atual: data.pagination.current_page || data.pagination.page || 1,
      estimated: data.pagination.total_pages || data.pagination.pages || 1,
      hasBefore: (data.pagination.current_page || 1) > 1,
      hasAfter: (data.pagination.current_page || 1) < (data.pagination.total_pages || 1),
      hasMorePages: (data.pagination.current_page || 1) < (data.pagination.total_pages || 1),
    };
  } else {
    const itemsCount = data?.data?.itens?.length || data?.itens?.length || 0;
    const totalItems = data?.data?.total || data?.total || itemsCount;

    if (totalItems > 0) {
      const estimatedPages = Math.ceil(totalItems / 100000);
      paginationInfo = {
        atual: 1,
        estimated: estimatedPages,
        hasBefore: false,
        hasAfter: estimatedPages > 1,
        hasMorePages: estimatedPages > 1,
      };
    }
  }

  return paginationInfo;
};
